import React, { useContext, useEffect } from "react";
import { Helmet } from 'react-helmet';
import {
    Button,
    Centered,
    CircularProgress,
    Paper, Space, Typography,
} from "../../../common/components/libs";
import { FormControl, Grid, Input, InputLabel, Link } from "@material-ui/core";
import { observer } from "mobx-react";
import { useStores } from "../../../hooks";
import NoPaymentData from "./NoPaymentData";
import { useHistory } from "react-router-dom";
import DocumentsStoreContext from "../context";
import { localize } from "../../../common/libs";
import { CompanyCardTypes } from "../../../services/organizationBranches/models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import styles from "./style.module.css";
import { IconProp } from "@fortawesome/fontawesome-svg-core";


const PaymentDataListPage = () => {

    const { generalStore, constantsStore } = useStores();
    const documentsStore = useContext(DocumentsStoreContext);
    const { isOrganizationBranchLoaded, organizationBranch } = documentsStore;
    const history = useHistory();

    useEffect(() => {
        generalStore.setPageTitle("Анкета");
        documentsStore.getOrganisationBranch();
    }, [generalStore, documentsStore]);


    const content = [];

    let applicationStatus;
    if (isOrganizationBranchLoaded && !documentsStore.organizationBranch.companyEntityData?.isCompanyCardLocked) {
        applicationStatus = false;
    } else if (isOrganizationBranchLoaded && documentsStore.organizationBranch.companyEntityData?.isCompanyCardLocked) {
        applicationStatus = true;
    }

    if (!isOrganizationBranchLoaded) {
        return (
            <Centered>
                <Paper
                    mt={2}
                    style={{
                        minHeight: "200px",
                        minWidth: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress m={2}/>
                </Paper>
            </Centered>
        )
    } else if (documentsStore.organizationBranch.companyEntityData.companyCard !== null && Object.keys(organizationBranch.companyEntityData.companyCard).length > 0) {
        const companyCard = documentsStore.organizationBranch.companyEntityData.companyCard;
        const tariff = documentsStore.organizationBranch.activeTariffDetails;
        const currencyFormatter = constantsStore.getCurrencyFormatter(tariff.monthlySubscriptionFee.currencyId);
        const docs = documentsStore.organizationBranch.privateDocs;

        content.push(
            <>
                <Typography component="h1" variant="h2" align="center">
                    Анкета
                </Typography>
                <Typography component="h3" variant="body2" align="center" gutterBottom>
                    на подключение приема платежей через restify.one
                </Typography>
                {!applicationStatus &&
                <Typography component="h3" variant="body1" align="center" gutterBottom style={{ color: "#1976d2" }}>
                    статус: на проверке
                </Typography>
                }
                {applicationStatus &&
                <Typography component="h3" variant="body1" align="center" gutterBottom style={{ color: "#85CC92" }}>
                    статус: принята
                </Typography>
                }
                <Space size={5}/>
            </>)
        content.push(
            <Centered>
                <Grid xs={12} md={8} xl={8}>
                    <Paper p={10}>
                        <Centered>
                            <form>
                                <Typography variant="h6">
                                    Общая информация
                                </Typography>
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="fullTitle">Полное наименование:</InputLabel>
                                    <Input
                                        value={localize(companyCard.fullTitle)}
                                        disabled
                                        rows={4}
                                    />
                                </FormControl>
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="shortTitle">Краткое наименование:</InputLabel>
                                    <Input
                                        value={localize(companyCard.shortTitle)}
                                        disabled
                                    />
                                </FormControl>
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="inn">ИНН:</InputLabel>
                                    <Input
                                        value={companyCard.inn}
                                        disabled
                                    />
                                </FormControl>
                                {(companyCard.type === CompanyCardTypes.RussianOOOCard) &&
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="ogrn">ОГРН:</InputLabel>
                                    <Input
                                        value={companyCard.ogrn}
                                        disabled
                                    />
                                </FormControl>
                                }
                                {(companyCard.type === CompanyCardTypes.RussianIPCard) &&
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="ogrn">ОГРНИП:</InputLabel>
                                    <Input
                                        value={companyCard.ogrnip}
                                        disabled
                                    />
                                </FormControl>
                                }
                                {(companyCard.type === CompanyCardTypes.RussianOOOCard) &&
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="kpp">КПП:</InputLabel>
                                    <Input
                                        value={companyCard.kpp}
                                        disabled
                                    />
                                </FormControl>
                                }
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="legalAdress">Юридический адрес:</InputLabel>
                                    <Input
                                        value={localize(companyCard.legalAddress)}
                                        disabled
                                    />
                                </FormControl>

                                <Typography variant="h6" mt={6}>
                                    Банковские реквизиты
                                </Typography>
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="bankCurrentAccountNumber">Расчетный счет:</InputLabel>
                                    <Input
                                        value={companyCard.bankCurrentAccountNumber}
                                        disabled
                                    />
                                </FormControl>
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="bankTitle">Наименование банка:</InputLabel>
                                    <Input
                                        value={localize(companyCard.bankTitle)}
                                        disabled
                                    />
                                </FormControl>
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="bankCorrespondentAccountNumber">Корреспондентский
                                        счет:</InputLabel>
                                    <Input
                                        value={companyCard.bankCorrespondentAccountNumber}
                                        disabled
                                    />
                                </FormControl>
                                <FormControl fullWidth margin={"normal"}>
                                    <InputLabel htmlFor="bankBik">БИК:</InputLabel>
                                    <Input
                                        value={companyCard.bankBik}
                                        disabled
                                    />
                                </FormControl>
                            </form>
                        </Centered>
                        <Space size={10}/>
                        <Centered>
                            <Grid xs={12} md={8} xl={8}>
                                <Typography variant="h6" align="left" gutterBottom style={{ margin: "10px 0" }}>
                                    Договор №{organizationBranch.id}
                                </Typography>
                                <Typography variant="body1" align="left">
                                    <Link href={"https://restify.one/documents/oferta-payments"}>Оферта подключения платежей</Link>
                                </Typography>
                                <Typography variant="body1" align="left">
                                    <Link href={docs.personalTermsUrl}>Индивидуальные условия подключения</Link>
                                </Typography>
                                <Typography variant="body1" align="left" gutterBottom style={{ margin: "10px 0" }}>
                                    <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                                    {currencyFormatter.toShowFormatted(tariff.monthlySubscriptionFee.price, true)} руб./месяц
                                    - абонентская плата
                                </Typography>
                                <Typography variant="body1" align="left" gutterBottom style={{ margin: "10px 0" }}>
                                    <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                                    {tariff.paymentProviderTransactionFeePercent + tariff.restifyTransactionFeePercent}%
                                    комиссии с каждой успешной оплаты по картам и 1% по СБП
                                </Typography>
                                <Typography variant="body1" align="left" gutterBottom style={{ margin: "10px 0" }}>
                                    <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                                    Полное соответствие 54-ФЗ
                                </Typography>
                                <Typography variant="body1" align="left">
                                    <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                                    Деньги на Ваш р/с в среднем через 2 дня после оплаты, но не позднее 10 рабочих дней.
                                </Typography>

                            </Grid>
                        </Centered>
                        {!documentsStore.organizationBranch.companyEntityData.isCompanyCardLocked &&
                        <Centered>
                            <Button
                                mt={2}
                                color="primary"
                                onClick={() => history.push("/documents/application-form")}
                            >
                                Редактировать анкету
                            </Button>
                        </Centered>
                        }
                    </Paper>
                </Grid>
            </Centered>
        )
    } else {
        content.push(
            <Centered key="noContent">
                <NoPaymentData/>
            </Centered>
        )
    }
    return (
        <>
            <Helmet title="Анкета"/>
            {content}
        </>
    );


};

export default observer(PaymentDataListPage);



